export default function getFormattedNumber(value, format, fractionDigits = 2, isDecimal = true, isPercentage = false) {
  if (!format) return value;

  const locale = format === 'dot' ? 'de-DE' : format === 'comma' ? 'en-US' : null;

  const formattedNumber = new Intl.NumberFormat(locale, {
    minimumFractionDigits: isDecimal ? fractionDigits : undefined,
  }).format(value);

  return isPercentage ? `${formattedNumber}%` : formattedNumber;
}